function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1924(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 12.54,
    height: 1.8,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 0.9
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.8,
    width: 12.54,
    height: 9.45,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 6.5249999999999995
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.25,
    width: 12.54,
    height: 21.61,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 22.055
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 32.86,
    width: 12.54,
    height: 26.06,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 45.89
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 58.91,
    width: 12.54,
    height: 28.07,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7914285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 72.945
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.99,
    width: 12.54,
    height: 30.69,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3933333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 102.335
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 117.68,
    width: 12.54,
    height: 50.96,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.508
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 143.16
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 168.64,
    width: 12.54,
    height: 52.21,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 194.74499999999998
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220.85,
    width: 12.54,
    height: 53.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 247.81
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 274.76,
    width: 12.54,
    height: 56.29,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 302.905
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 331.06,
    width: 12.54,
    height: 60.93,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.135
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 361.525
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 391.98,
    width: 12.54,
    height: 67.39,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3933333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 425.675
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 459.37,
    width: 12.54,
    height: 78.36,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 498.55
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 537.73,
    width: 12.54,
    height: 80.13,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.09
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 577.7950000000001
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 617.86,
    width: 12.54,
    height: 82.14,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.254
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 6.27,
    y: 658.9300000000001
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 0,
    width: 27.5,
    height: 41.57,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.29,
    y: 20.785
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.04,
    y: 0,
    width: 27.5,
    height: 41.57,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0555555555555554
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 20.785
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.55,
    y: 0,
    width: 29.61,
    height: 41.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.922
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.35499999999999,
    y: 20.785
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.15,
    y: 0,
    width: 29.78,
    height: 41.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.963333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.04,
    y: 20.785
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.94,
    y: 0,
    width: 32.72,
    height: 41.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.3,
    y: 20.785
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.65,
    y: 0,
    width: 32.95,
    height: 41.57,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.491666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.125,
    y: 20.785
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.6,
    y: 0,
    width: 34.78,
    height: 41.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.99,
    y: 20.785
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.37,
    y: 0,
    width: 38.87,
    height: 41.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.478333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.805,
    y: 20.785
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.24,
    y: 0,
    width: 42.77,
    height: 41.57,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.928333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 287.625,
    y: 20.785
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.01,
    y: 0,
    width: 50.09,
    height: 41.57,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.3925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 334.055,
    y: 20.785
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.09,
    y: 0,
    width: 51.71,
    height: 41.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.314
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.945,
    y: 20.785
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.81,
    y: 0,
    width: 55.02,
    height: 41.57,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.928333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 438.32,
    y: 20.785
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 465.83,
    y: 0,
    width: 55.22,
    height: 41.57,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.19625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.44,
    y: 20.785
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.05,
    y: 0,
    width: 56.43,
    height: 41.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.618888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.265,
    y: 20.785
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.48,
    y: 0,
    width: 60.47,
    height: 41.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.3925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.715,
    y: 20.785
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 637.94,
    y: 0,
    width: 62.06,
    height: 41.57,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.928333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.97,
    y: 20.785
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 41.57,
    width: 63.69,
    height: 41.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 62.19
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 82.81,
    width: 63.69,
    height: 46.58,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1053333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 106.1
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 129.39,
    width: 63.69,
    height: 46.62,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 152.7
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 176.01,
    width: 63.69,
    height: 52.54,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.505714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 202.28
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 228.56,
    width: 63.69,
    height: 53.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.329
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 255.205
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 281.84,
    width: 63.69,
    height: 59.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 311.73499999999996
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 341.63,
    width: 63.69,
    height: 62.25,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 372.755
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 403.88,
    width: 63.69,
    height: 64.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.738
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 436.28999999999996
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 468.7,
    width: 63.69,
    height: 71.48,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.96125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 504.44
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 540.18,
    width: 63.69,
    height: 79.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.369
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 580.125
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.54,
    y: 620.07,
    width: 63.69,
    height: 79.93,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.899230769230769
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.385,
    y: 660.0350000000001
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.23,
    y: 41.57,
    width: 74.04,
    height: 75.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 79.52000000000001
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.27,
    y: 41.57,
    width: 78.14,
    height: 75.9,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.34,
    y: 79.52000000000001
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.41,
    y: 41.57,
    width: 83.46,
    height: 75.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.14,
    y: 79.52000000000001
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.87,
    y: 41.57,
    width: 85.75,
    height: 75.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.745,
    y: 79.52000000000001
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.62,
    y: 41.57,
    width: 94.04,
    height: 75.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.64,
    y: 79.52000000000001
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.66,
    y: 41.57,
    width: 94.49,
    height: 75.9,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.905,
    y: 79.52000000000001
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.15,
    y: 41.57,
    width: 113.85,
    height: 75.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.0749999999999,
    y: 79.52000000000001
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.23,
    y: 117.47,
    width: 105.21,
    height: 101.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.2821428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.835,
    y: 168.445
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.23,
    y: 219.42,
    width: 105.21,
    height: 107.42,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.835,
    y: 273.13
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.23,
    y: 326.84,
    width: 105.21,
    height: 118.5,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.520999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.835,
    y: 386.09
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.23,
    y: 445.34,
    width: 105.21,
    height: 125.59,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.564545454545454
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.835,
    y: 508.135
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.23,
    y: 570.93,
    width: 105.21,
    height: 129.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.535
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 128.835,
    y: 635.4649999999999
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.44,
    y: 117.47,
    width: 134.48,
    height: 131.86,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.651111111111113
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.68,
    y: 183.4
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.93,
    y: 117.47,
    width: 384.07,
    height: 131.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.837142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 507.96500000000003,
    y: 183.4
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.44,
    y: 249.33,
    width: 130.55,
    height: 450.67,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.042307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.715,
    y: 474.665
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 249.33,
    width: 388,
    height: 450.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 35.27272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506,
    y: 474.665
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1924);
export default __webpack_public_path__ + "static/media/1924.b05236dbddd3436d1437e0e666fd72d0.svg";
export { ForwardRef as ReactComponent };